import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import capitalize from 'rebook/apps/utils/text/capitalize';

import styles from './style.scss';


const SpinnerLoader = ({ theme, size, isMargined, extraClassName, width, height }) => {
  const style = { width, height };
  return (
    <span style={style} className={classNames(
      styles.spinnerLoader,
      theme && `theme${capitalize(theme)}`,
      size && `${size}Size`,
      { isMargined },
      extraClassName,
    )}>
      <svg className={styles.circular} viewBox="25 25 50 50">
        <circle
          className={styles.path}
          cx="50" cy="50" r="20"
          fill="none"
          strokeMiterlimit="10" />
      </svg>
    </span>
  );
};

SpinnerLoader.defaultProps = {
  theme: null,
  size: null,
  width: '32px',
  height: '32px',
};

SpinnerLoader.propTypes = {
  theme: PropTypes.string,
  size: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default SpinnerLoader;
